/**
 * Der Aufruf der Befehlspalette von aussen.
 *
 * Ein eigenes Ereignis und kein nachgebauter Tastendruck: Ein erfundenes
 * ``KeyboardEvent`` waere von einem echten nicht zu unterscheiden und liefe
 * durch jede andere Tastaturbehandlung der Anwendung mit. Und ein Zustand im
 * Wurzelelement waere einer, den jede Seite dazwischen weiterreichen
 * muesste, obwohl ihn genau zwei Stellen brauchen.
 */
export const PALETTE_OPEN_EVENT = 'itscrm:open-palette';

/** Oeffnet die Befehlspalette -- fuer den Knopf in der Kopfleiste. */
export function openCommandPalette(): void {
  window.dispatchEvent(new CustomEvent(PALETTE_OPEN_EVENT));
}
